import React from 'react';

interface Address {
  street: string;
  city: string;
  landmark: string;
  pincode: string;
}

interface AddressFormProps {
  address: Address;
  onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  onSubmit: () => void;
  disabled: boolean;
}

const AddressForm: React.FC<AddressFormProps> = ({ address, onChange, onSubmit, disabled }) => {
  return (
    <form
      className="space-y-4 max-w-md mx-auto"
      onSubmit={e => {
        e.preventDefault();
        onSubmit();
      }}
    >
      <input
        type="text"
        name="street"
        placeholder="Street Address"
        value={address.street}
        onChange={onChange}
        className="w-full p-2 border rounded"
        required
      />
      <input
        type="text"
        name="city"
        placeholder="City"
        value={address.city}
        onChange={onChange}
        className="w-full p-2 border rounded"
        required
      />
      <input
        type="text"
        name="landmark"
        placeholder="Landmark (optional)"
        value={address.landmark}
        onChange={onChange}
        className="w-full p-2 border rounded"
      />
      <input
        type="text"
        name="pincode"
        placeholder="Pincode"
        value={address.pincode}
        onChange={onChange}
        className="w-full p-2 border rounded"
        required
      />
      <button
        type="submit"
        className={`w-full py-2 rounded-xl font-medium ${disabled ? 'bg-gray-300 text-gray-500' : 'bg-minto-500 hover:bg-minto-600 active:bg-minto-700 text-white transition-colors'}`}
        disabled={disabled}
      >
        Book Now
      </button>
    </form>
  );
};

export default AddressForm; 